import React, { FC, useEffect } from 'react';
import ImageGuideUpgrade from '@/assets/images/page/image-guide-upgrade.react.svg?react';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { useStores } from '@/presentation/store';
import { onUpgrade } from './auth';

export enum ImageGuideUpgradeType {
  showStorage = 0,
  disableAny = 1
}


export interface IProps {
  type: ImageGuideUpgradeType
  reportGuideType?: string
  reportScene?: string
  reportField?: string
}


export const ImageGuideUpgradeCard: FC<IProps> = (props) => {
  const { reportScene, reportGuideType, reportField } = props;
  const { pgid } = useStores().LayoutStore;
  useEffect(() => reportClick(reportScene!, CUSTOM_ACTIONS.guideUpgradeView, {
    from: pgid,
    param3: reportGuideType,
    param4: reportField,
  }), []);
  const reportProps = { reportScene, pgid, reportGuideType, reportField };
  return (props.type === ImageGuideUpgradeType.disableAny ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ImageGuideUpgrade />
      <div>
        体验产品不支持此功能，
      </div>
      <div>
        请<a onClick={() => onUpgrade(reportProps)}>购买资源包</a>，升级为付费产品后再使用。
      </div>
    </div>
  ) : (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ImageGuideUpgrade />
      <div>
        体验产品的明细仅存储7天。
        <br />请<a onClick={() => onUpgrade(reportProps)}>购买资源包</a>
        ，升级为付费产品，可享受最长90天的明细存储。
      </div>
    </div>
  ));
};

